import { del, get, post } from './index';

const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';

const enrich = users => {
  users.forEach(user => {
    user.fullName = `${user.firstName} ${user.lastName}`;
  });

  return users;
}

export const getLiftoffUsers = async () => {
  let users = [];

  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(enrich(require('./mock-data/liftoffUsers.json')));
      }, 200);
    });
  } else {
    users = await get(`/liftoff_get_users`);
  }

  return enrich(users);
};

export const getLiftoffUserRoles = async () => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(enrich(require('./mock-data/liftoffUserRoles.json')));
      }, 200);
    });
  }

  return await get(`/liftoff_get_user_roles`);
};

export const createLiftoffUser = async (email, firstName, lastName, roles) => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200
        });
      }, 1000);
    });
  }

  return await post(`/liftoff_create_user`, {
    email, firstName, lastName, roles
  });
};

export const removeLiftoffUser = async (email) => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200
        });
      }, 1000);
    });
  }

  return await del(`/liftoff_remove_user`, {
    email
  });
};

export const assignLiftoffUserRoles = async (email, roles) => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          status: 200
        });
      }, 1000);
    });
  }

  return await post(`/liftoff_assign_user_roles`, {
    email, roles
  });
};